<template>
  <div class="wrapper">
    <div class="bg-image"></div>
    <div class="logo"></div>
    <div class="verify-form">
      <div v-if="verified">
        <img src="../assets/like.png" class="web-image">
        <h1>EMAIL IS VALIDATED</h1>
        <p>Return to the app and fully enjoy Wotive.</p>
      </div>
      <div v-else>
        <img src="../assets/like.png" class="web-image">
        <h1>EMAIL IS BEING VERIFIED</h1>
        <p>Please wait</p>
      </div>
    </div>
  </div>
</template>

<script>
import { verifyEmail } from '@/api/requests';

export default {
  name: 'VerifyEmail',

  data() {
    return {
      errorMsg: '',
      verified: false,
    };
  },

  mounted() {
    this.verifyEmailRequest();
  },

  methods: {
    verifyEmailRequest() {
      const token = this.$route.query.token;

      let res = verifyEmail({token: token}).then(response => {
        this.verified = true;
      }).catch(() => {
        // TODO errors
        this.errorMsg = "Something went wrong! Maybe the token has expired. Please try again, and contact support if this keeps happening.";
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.wrapper {
  background-color: $sec0;
  position: absolute;
  width: 100%;
  height: 100%;

  .logo {
    height: 80px;
    background-image: url(~@/assets/wotive-logo.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    margin: auto;
    margin-top: $spacing-base;
  }

  .bg-image {
    position: absolute;
    right: 0;
    width: 60%;
    height: 100%;
    background-image: url(~@/assets/landing-page/muscle-map.svg);
    background-repeat: no-repeat;
    background-size: cover;
    z-index: 1;
  }

  .verify-form {
    padding: $spacing-base;
    box-sizing: border-box;
    margin: auto;
    z-index: 2;
    width: 100%;
    max-width: 700px;
    display: flex;
    position: relative;
    justify-content: center;

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: $spacing-large;
      max-width: 400px;
      width: 100%;
    }

    img {
      margin-top: $spacing-large * 2;
    }

    h1 {
      margin: 0;
      padding: 0;
      text-align: center;
      color: #fff;
      font-weight: 500;
      font-size: 24px;
      margin-top: $spacing-small;
    }

    p {
      margin-top: $spacing-small;
      margin-bottom: 0;
      color: $sec6;
      text-align: center;
      font-size: 14px;
    }

    .error {
      font-size: 10px;
      line-height: 12px;
      text-align: center;
      color: $red1;
      margin: 0;
      height: 20px;
      border: 0;
    }

    .error-msg-input {
      margin-bottom: 0;
    }

    .input-holder {
      width: 100%;
      position: relative;

      p {
        width: 100%;
        position: absolute;
        bottom: -12px;
      }
    }
    
    .margin-bottom {
      margin-bottom: $spacing-base;
    }

    label {
      font-size: $font-size-small;
      text-align: center;
      color: $sec5;
      font-weight: 500;
    }

    .remember-me {
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        font-weight: bold;
        color: $sec5;
      }
    }

    input[type=text],
    input[type=password] {
      width: 100%;
      height: 40px;
      box-sizing: border-box;
      border-radius: 0;
      border: 0;
      background: $sec7;
      margin-bottom: $spacing-small;
      padding: 8px;
      background-color: $sec2;
      color: $sec7;
    }

    input[type=text]:focus,
    input[type=password]:focus {
      outline: none !important;
      border:1px solid $blue;
    }

    button {
      margin-top: $spacing-base;
      background-color: $blue;
      color: #fff;
      border: 0;
      height: 40px;
      width: 100%;
      border-radius: $border-radius;
      font-weight: bold;
    }
  }
}
</style>
